var _rect, _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgImageIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 22,
  height: 14,
  x: 1,
  y: 5,
  stroke: "currentColor",
  strokeLinejoin: "round",
  strokeWidth: 2,
  rx: 2
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeWidth: 2,
  d: "m23 17-4.34-3.906a1 1 0 0 0-1.328-.01l-2.572 2.25a1 1 0 0 1-1.418-.101L8.78 9.91a1 1 0 0 0-1.536.02L1.5 17"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 15,
  cy: 9,
  r: 2,
  fill: "currentColor"
})));
export default SvgImageIcon;